export const routes = [
	{
		name: 'For Depositors',
		link: '/',
	},
	{
		name: 'For DAO Managers',
		link: '/managers',
	},
	// {
	// 	name: 'Pricing',
	// 	link: '/pricing',
	// },
];

export const docsUrl = 'https://docs.weezi.io/';
